module.exports = __webpack_public_path__ + "img/workshop_prozessmodell.f61133eb.png";